import { Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function Heading({ student, school, onClose }) {
  const { t } = useTranslation();

  return (
    <Box p={2} borderBottom="1px solid" borderColor="divider" bgcolor="background.main" display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography variant="h6" fontWeight="bold">
          {t("Enrollment Progress")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {student?.firstName} {student?.lastName} - {t("Grade")} {student?.studentGr?.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {school?.school?.name}
        </Typography>
      </Box>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
  );
}
